import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import { getRequestsPendings } from '../api';
import { StudentsRemovalRequestsPendingResponse } from '../types';

export const ITEMS_PER_PAGE_DEFAULT = 10;

export interface StudentsRemovalRequestsPendingQuery {
  page: number;
  studentNameOrId?: string;
  studyPlanVersionId?: number;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  StudentsRemovalRequestsPendingQuery,
  StudentsRemovalRequestsPendingResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestsPendingtList = useFetch;

export function StudentsRemovalRequestsPendingListConsumer({
  children,
}: {
  children: (args: {
    data?: StudentsRemovalRequestsPendingResponse;
    loading: boolean;
    refresh: () => Promise<void>;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              insideCard
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data, loading, refresh });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestsPendingListLoader({
  children,
}: {
  children: ReactElement | ReactElement[];
}) {
  const request = useCallback(
    async (query: StudentsRemovalRequestsPendingQuery) => {
      return getRequestsPendings({
        ...query,
        studentNameOrId: query.studentNameOrId || undefined,
        page: query.page - 1,
      });
    },
    [],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1 }}
      children={children}
      fetchImmediately
    />
  );
}
